import request from '../../axios';

export const getNotificationCount = async () => {
  const {data}: {data: {unseen_notifications_count: number}} =
    await request.get(`/api/v2/notification/count-store-notification`);

  return data;
};
